/* 删除数组属性为空 */
export const deleteNullKey = (obj: any) => {
  // obj为undefined时，返回空对象
  if (obj === undefined) {
    return {}
  }
  Object.keys(obj).forEach((item) => {
    if (obj[item] === null) {
      delete obj[item]
    }
  })
  return obj
}

// 排序的函数
export const objKeySort = (obj: any) => {
  const sortObj = {} as any
  let Objarr: any = {} as any
  const arrChild: {}[] = []
  Object.keys(obj)
    .sort()
    .forEach((item) => {
      if (obj[item] instanceof Array) {
        obj[item].forEach((index: number) => {
          if (typeof index === 'object') {
            Object.keys(index)
              .sort()
              .forEach((indexKey) => {
                Objarr[indexKey] = index[indexKey]
              })
            arrChild.push(Objarr)
            Objarr = {} // 每push一次把对象中的值清空一次
            obj[item] = arrChild // 把排好序的重新赋值
          }
        })
      }
      sortObj[item] = obj[item] // 最外面对象排序赋值
    })
  return sortObj
}

// 需要验签的接口
export const arr = ['/applicationManagement/v2/queryApplicationVersion']
export const getAssetsImages = (name: string) => {
  return new URL(`../assets/image/${name}`, import.meta.url).href
}


/**
 * base64 转换成 blob
 * @param dataUrl
 * @returns
 */
export const dataURLtoBlob = (dataUrl: any) => {
  const arr = dataUrl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
};

/**
 * blob 转换为 file
 * @param blobObj
 * @param fileName
 * @returns
 */
export const blobToFile = (blobObj: any, fileName: string) => {
  blobObj.lastModifiedDate = new Date(); // 文件最后的修改日期
  blobObj.name = fileName; // 文件名
  return new File([blobObj], fileName, { type: blobObj.type, lastModified: Date.now() });
};

/**
 * base64 转 file 对象
 * // 先将base64转换成blob，再将blob转换成file文件，此方法不存在浏览器不兼容问题
 * @param dataUrl
 * @param fileName
 * @returns
 */
export const base64ToFile = (dataUrl: String, fileName: string) => {
  const theBlob = dataURLtoBlob(dataUrl);
  return blobToFile(theBlob, fileName);
};